<div>
    <!-- header -->
    <h2 mat-dialog-title mat-dialog-draggable-title> {{'title.synchronized_digital_certificate' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="onBtnCancelClick()">
            <span aria-hidden="true">&times;</span>
        </button>
    </h2>
    <!-- end header -->
    <mat-divider></mat-divider>
    <mat-dialog-content>
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                    {{ "title.search_condition" | translate }}
                </mat-panel-title>
                <form #f="ngForm" class="pb-3" (ngSubmit)="onClickBtnFilter()" (keydown.enter)="onClickBtnFilter()">
                    <div class="row">
                        <div class="col-3">
                            <mat-form-field class="w-100">
                                <mat-select id="typeCertificate" name="typeCertificate"
                                    [placeholder]="'digital-certificate-default.dialog_add.field_certificate' | translate"
                                    [(ngModel)]="digitalCertificate.typeCertificate"
                                    (ngModelChange)="onClickBtnFilter()">
                                    <mat-option value="null">
                                        {{'enterprise-certificate_management.cbx_certificate_type.cbx_all' | translate}}
                                    </mat-option>
                                    <mat-option value="2">
                                        {{'enterprise-certificate_management.cbx_certificate_type.cbx_card_CA' |
                                        translate}}
                                    </mat-option>
                                    <mat-option value="1">
                                        {{'enterprise-certificate_management.cbx_certificate_type.cbx_usb_token' |
                                        translate}}
                                    </mat-option>
                                    <mat-option value="0" *ngIf="isHsmPermission">
                                        {{'enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server'
                                        | translate}}
                                    </mat-option>
                                    <mat-option value="3" *ngIf="userType == 5">
                                        {{'enterprise-certificate_management.cbx_certificate_type.cbx_OTP' | translate}}
                                    </mat-option>
                                    <mat-option [value]="certificateType.CLOUD_CA">
                                        {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' |
                                        translate}}
                                    </mat-option>
                                </mat-select>
                                <button mat-button *ngIf="digitalCertificate.typeCertificate" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="digitalCertificate.typeCertificate=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="col-5">
                            <mat-form-field class="w-100">
                                <input
                                    (focusout)="digitalCertificate.search = digitalCertificate.search == undefined ? '' : (digitalCertificate.search + '').trim()"
                                    #focusInput matInput type="text"
                                    [placeholder]="'search_form.name_or_serial' | translate" name="name"
                                    [(ngModel)]="digitalCertificate.search" autocomplete="off" />
                                <button mat-button *ngIf="digitalCertificate.search" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="digitalCertificate.search=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <mat-form-field class="w-100">
                                <mat-select id="syncStatus" name="syncStatus"
                                    [placeholder]="'headertable.sync_status' | translate"
                                    [(ngModel)]="digitalCertificate.syncStatus" (ngModelChange)="onClickBtnFilter()">
                                    <mat-option value="">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_select_all"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="SYNCED">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_synced"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="NOT_SYNCED">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_not_synced"
                                        | translate
                                        }}
                                    </mat-option>
                                </mat-select>
                                <button mat-button *ngIf="digitalCertificate.syncStatus" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="digitalCertificate.syncStatus=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <button mat-stroked-button color="primary" type="submit">
                                <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
                                {{ "search_form.search" | translate }}
                            </button>
                        </div>
                    </div>
                </form>

                <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                    <span
                        *ngIf="!commonService.getIsLockedEnterprise()">{{'enterprise-certificate_management.list_certificate_sync'
                        |
                        translate}}
                        ({{paginate.totalRow}}), {{'enterprise_customer_management.selected' | translate}}
                        {{this.dataSelected.size}}
                    </span>
                    <span
                        *ngIf="commonService.getIsLockedEnterprise()">{{'enterprise-certificate_management.list_certificate_sync'
                        |
                        translate}}
                        ({{paginate.totalRow}})
                    </span>
                </mat-panel-title>

                <div class="mat-table-container">
                    <mat-table [dataSource]="dataSource" width="100%">
                        <!-- check-->
                        <ng-container matColumnDef="check">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                                <mat-checkbox [disabled]="commonService.getIsLockedEnterprise()"
                                    *ngIf="dataSource && dataSource.data && dataSource.data.length > 0"
                                    [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                <mat-checkbox color="primary" [(ngModel)]="element.checked"
                                    (change)="onSelectionChange(element)"
                                    [disabled]="commonService.getIsLockedEnterprise()">
                                </mat-checkbox>
                            </mat-cell>
                        </ng-container>
                        <!-- STT -->
                        <ng-container matColumnDef="id">
                            <mat-header-cell *matHeaderCellDef
                                class="special mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                <div>{{'enterprise_contract.table_headers.No' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                {{paginate.no[dataSource.filteredData.indexOf(element)]}}
                            </mat-cell>
                        </ng-container>

                        <!-- Phương thức ký -->
                        <ng-container matColumnDef="typeCertificate">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'enterprise-certificate_management.table_headers.digital_certificate_type' |
                                translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="text-center mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                <div *ngIf="element.typeCertificate == 0" class="w-100 text-left">
                                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_sign-number-server' |
                                    translate}}
                                </div>
                                <div *ngIf="element.typeCertificate == 1" class="w-100 text-left">
                                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_usb_token' |
                                    translate}}
                                </div>
                                <div *ngIf="element.typeCertificate == 2" class="w-100 text-left">
                                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_card_CA' | translate}}
                                </div>
                                <div *ngIf="element.typeCertificate == 3" class="w-100 text-left">
                                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_OTP' | translate}}
                                </div>
                                <div *ngIf="element.typeCertificate == 4" class="w-100 text-left">
                                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_HSM' | translate}}
                                </div>
                                <div *ngIf="element.typeCertificate == certificateType.CLOUD_CA"
                                    class="w-100 text-left">
                                    {{'enterprise-certificate_management.cbx_certificate_type.cbx_CLOUD_CA' |
                                    translate}}
                                </div>
                            </mat-cell>
                        </ng-container>

                        <!-- Tên chủ thể -->
                        <ng-container matColumnDef="issuedTo">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'enterprise-certificate_management.table_headers.subject_name' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom word-break-line"
                                matTooltip="{{element.issuedTo}}">
                                {{element.issuedTo}}
                            </mat-cell>
                        </ng-container>

                        <!-- Serial number -->
                        <ng-container matColumnDef="serialNumber">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'enterprise-certificate_management.table_headers.serial_number' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom word-break-line"
                                matTooltip="{{element.serialNumber}}">
                                {{element.serialNumber}}
                            </mat-cell>
                        </ng-container>



                        <!-- Mã số thuế -->
                        <ng-container matColumnDef="taxCode">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'enterprise-certificate_management.table_headers.tax_code_cmtnd' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-cell-non-boder-right-bottom number-cell-right word-break-line"
                                matTooltip="{{element.taxCode}}">
                                {{element.taxCode}}
                            </mat-cell>
                        </ng-container>

                        <!-- Số điện thoại -->
                        <ng-container matColumnDef="phoneNumber">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'enterprise-certificate_management.table_headers.phone_number' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                                {{element.phoneNumber}}
                            </mat-cell>
                        </ng-container>

                        <!-- Ngày hiệu lực -->
                        <ng-container matColumnDef="activeDate">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                                {{'enterprise-certificate_management.table_headers.effective_date' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-cell-non-boder-right-bottom number-cell-center word-break-line">
                                {{element.activeDate | dateformat}}
                            </mat-cell>
                        </ng-container>

                        <!-- Ngày hết hạn -->
                        <ng-container matColumnDef="expireDate">
                            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center">
                                {{'enterprise-certificate_management.table_headers.expiry_date' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" class="number-cell-center word-break-line">
                                {{element.expireDate | dateformat}}
                            </mat-cell>
                        </ng-container>

                        <!-- Trạng thái -->
                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                                {{'enterprise_group_user_management.table_headers.status' | translate}}
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" style="max-width: 10%;"
                                class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom word-break-line">
                                <div matTooltip="{{'enterprise-certificate_management.tooltips.active' | translate}}"
                                    *ngIf="element.certificateStatus == 0 && element.isDeleted === false"
                                    class="w-100 text-center" style="color: #09847b">
                                    {{'enterprise-certificate_management.certificate_status.active' | translate}}
                                </div>
                                <div matTooltip="{{'enterprise-certificate_management.tooltips.active' | translate}}"
                                    *ngIf="element.isDeleted === true" class="w-100 text-center" style="color: #09847b">
                                    {{'enterprise-certificate_management.certificate_status.inactive' | translate}}
                                </div>
                                <div matTooltip="{{'enterprise-certificate_management.tooltips.pending' | translate}}"
                                    *ngIf="element.certificateStatus == 1 && element.isDeleted === false"
                                    class="w-100 text-center" style="color: #da190b">
                                    {{'enterprise-certificate_management.certificate_status.pending' | translate}}
                                </div>
                                <div matTooltip="{{'enterprise-certificate_management.tooltips.expired' | translate}}"
                                    *ngIf="element.certificateStatus == 2 && element.isDeleted === false"
                                    class="w-100 text-center">
                                    {{'enterprise-certificate_management.certificate_status.expired' | translate}}
                                </div>
                                <div matTooltip="{{'enterprise-certificate_management.tooltips.revoked' | translate}}"
                                    *ngIf="element.certificateStatus == 5 && element.isDeleted === false"
                                    class="w-100 text-center">
                                    {{'enterprise-certificate_management.certificate_status.revoked' | translate}}
                                </div>
                            </mat-cell>
                        </ng-container>


                        <!-- Trạng thái đồng bộ Column -->
                        <ng-container matColumnDef="status_sync">
                            <mat-header-cell *matHeaderCellDef style="max-width: 160px"
                                class="special mat-header-cell-center">
                                <div>{{'headertable.sync_status' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.syncStatusMessage }}"
                                style="max-width: 160px" (click)="$event.stopPropagation()" class="number-cell-center">
                                <span *ngIf="element.syncStatus === 'SYNCED'" class="title-status-sync synced">{{
                                    'system_document_template.cbx_document_status.cbx_document_status_synced' |
                                    translate
                                    }}</span>
                                <span *ngIf="element.syncStatus === 'NOT_SYNCED'"
                                    class="title-status-sync not-synced">{{
                                    'system_document_template.cbx_document_status.cbx_document_status_not_synced' |
                                    translate }}</span>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    </mat-table>
                </div>
                <!-- Pagination -->
                <app-pagination [(paginate)]="paginate" (pageChange)="onPageChange($event.page, $event.pageSize)">
                </app-pagination>
                <!-- /Pagination -->
            </mat-expansion-panel>
        </mat-accordion>
    </mat-dialog-content>
    <div>
        <p class="mb-0 mt-3">
            <b><i>{{'synchronized.note' | translate}}</i></b>
            <i>{{'synchronized.synchronized_note' | translate}}</i>
        </p>
    </div>
    <!-- Huỷ bỏ & Đồng bộ & Đồng bộ tất cả  -->
    <mat-dialog-actions class="mt-2" align="center">
        <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="onBtnCancelClick()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.close' | translate}}
        </button>
        <button mat-raised-button type="button" color="primary" class="mr-3" (click)="synchronizeSelectedRecords()"
            [disabled]="this.dataSelected.size == 0">
            <mat-icon class="mr-0">refresh</mat-icon>
            {{'button.synchronized' | translate}}
        </button>
        <button mat-raised-button type="button" color="primary" (click)="synchronizeAll()"
            [disabled]="this.dataSource.data.length == 0">
            <mat-icon class="mr-0">folder</mat-icon>
            {{'button.synchronized_all' | translate}}
        </button>
    </mat-dialog-actions>
</div>